/**
 * Handles common tasks for the product Sliders.
 * @namespace
 */
const productSlider = {
	/**
	 * Used for Facebook pixel tracking.
	 * @type {Array}
	 */
	facebook_content_ids: [],
	/**
	 * Used for Facebook pixel tracking.
	 * @type {Array}
	 */
	facebook_tracked_item_ids: [],
	isLoading: false,
	/**
	 * Keeps track of cart item IDs for products added to the cart.
	 * @type {Object} The cart item IDs indexed by the product IDs.
	 */
	itemsAddedToCart: {},
	/**
	 * Initializes all event listeners for product Sliders. Init is executed on document ready.
	 * @returns {undefined}
	 */
	init: function() {
		this.loadVehicleFitProducts();
		this.loadTopPurchasedVehicleFitProducts();
		this.loadComboProductsBundle();
		$(document.body).on('click', '.productSlider a.addToCartBtn.addToCartAutoLoadCouponProductCat', function (e) {
			e.preventDefault();
			let $this = $(this),
				productId = $this.data('productId'),
				itemsArray = [productId],
				redeemedCode = $this.data('couponCode'),
				// type cast to string, sometimes it returns a number when only one product id
				couponProductIds = (($this.data('couponProductIds') || '') + '').split(',');
			
			couponProductIds.forEach(function(couponProductId) {
				if(couponProductId && couponProductId != '0') {
					itemsArray.push(couponProductId);
				}
			});
			
			$('#ajaxloader').show();
			sonicGlobal.overlayActivate(true);
			$(document.body).data('triggeredAddToCartBtn', 'addToCartAutoLoadCouponProductCat');
			productSlider.addItemToCart(itemsArray, redeemedCode, productId);
		});
	},

	/**
	 * Sets up show/hide behavior for combo product bundle-includes content.
	 * @returns {undefined}
	 */
	loadComboProductsBundle: function() {
		// Guard against double-initialisation (e.g. AJAX reloads)
		if ($('.comboBundleFloatingDropdown').length) return;

		const $floating = $('<div/>', { class: 'comboBundleFloatingDropdown' })
			.hide()
			.appendTo('body');

		let activeToggle = null;
		let activeAnchor = null;

		const setLabels = (toggle, open) => {
			toggle.setAttribute('aria-expanded', String(open));
			const $toggle = $(toggle);
			$toggle.find('.viewItems').css('display', open ? 'none' : '');
			$toggle.find('.hideItems').css('display', open ? '' : 'none');
		};

		const position = () => {
			if (!activeToggle || !activeAnchor) return;

			// Ensure it's measurable while open
			$floating.css('display', 'block');

			const toggleRect = activeToggle.getBoundingClientRect();
			const anchorRect = activeAnchor.getBoundingClientRect();

			const width = Math.min(anchorRect.width, window.innerWidth - 16);

			let left = anchorRect.left;
			left = Math.max(8, Math.min(left, window.innerWidth - width - 8));

			const top = toggleRect.bottom + 4;

			$floating.css({
				width: `${width}px`,
				left: `${left}px`,
				top: `${top}px`,
				maxHeight: `${Math.floor(window.innerHeight * 0.6)}px`,
			});

			// Optional flip
			const fr = $floating[0].getBoundingClientRect();
			if (fr.bottom > window.innerHeight - 8) {
				$floating.css('top', `${Math.max(8, toggleRect.top - fr.height - 4)}px`);
			}
		};

		// Close with animation, then run callback (used for "switch to another")
		const closeAnimated = (after) => {
			if (!activeToggle) {
				if (typeof after === 'function') after();
				return;
			}

			const prevToggle = activeToggle; // capture

			setLabels(prevToggle, false);

			// stop current animations, slide up, then cleanup
			$floating.stop(true, true).slideUp(150, () => {
				$floating.removeClass('open').empty();

				// Only clear active* if we didn't already switch them
				// (we clear them here because slideUp finished)
				if (activeToggle === prevToggle) {
					activeToggle = null;
					activeAnchor = null;
				}

				if (typeof after === 'function') after();
			});
		};

		// Open a given toggle/dropdown
		const openFor = (toggle, anchor, dropdown) => {
			activeToggle = toggle;
			activeAnchor = anchor;

			setLabels(toggle, true);

			$floating.html(dropdown.outerHTML).addClass('open');

			position();

			$floating.stop(true, true).hide().slideDown(150);
		};

		// Toggle click
		$(document).on('click', '.comboBundleIncludesToggle', (e) => {
			const toggle = e.currentTarget;

			e.preventDefault();

			const dropdown = toggle.parentElement?.querySelector('.comboBundleIncludesDropdown');
			if (!dropdown) return;

			const anchor =
				toggle.closest('.comboBundleSavingsCont') ||
				toggle.closest('.comboBundleIncludesBlock') ||
				toggle.closest('.productContainer');
			if (!anchor) return;

			// Same toggle => just close (slide up)
			if (activeToggle === toggle) {
				closeAnimated();
				return;
			}

			// Different toggle while one is open:
			// slide the old one up FIRST, then open the new one
			closeAnimated(() => openFor(toggle, anchor, dropdown));
		});

		// Close when clicking outside
		$(document).on('click', (e) => {
			if (!activeToggle) return;
			if ($(e.target).closest('.comboBundleFloatingDropdown, .comboBundleIncludesToggle').length) return;
			closeAnimated();
		});

		// Keep aligned on scroll/resize
		window.addEventListener('scroll', position, { capture: true, passive: true });
		window.addEventListener('resize', position, { passive: true });
	},

	/**
	 * Handles infinite scrolling for the vehicle fit product list slider.
	 * Loads additional products when the user scrolls to the end.
	 *
	 * - Retrieves the total number of pages from the slider's data attribute.
	 * - Detects when the user reaches the horizontal scroll end.
	 * - Calls `productSlider.loadMoreProducts` to load the next page of products.
	 *
	 * @function loadVehicleFitProducts
	 * @returns {void}
	 */
	loadVehicleFitProducts: function () {
		let vehicleFitProductListSlider = $('.vehicleFitProductListSlider'),
			productsPLaceholder = $(".vehicleFitProductListSlider .defaultProductSlider"),
			page = 1,
			url = new URL(window.location.href),
			path = url.pathname + url.search + url.hash,
			maxPages = vehicleFitProductListSlider.data('pageCount');
		$(".vehicleFitProductListSlider .horizontalCustomScrollbar").on("scroll", function () {
			let $this = $(this);
			if (!productSlider.isLoading && page < maxPages && $this.scrollLeft() + $this.innerWidth() >= $this[0].scrollWidth - 10) {
				productSlider.isLoading = true;
				page++;
				productSlider.loadMoreProducts(path, page, 'loadMoreVehicleFitProducts', productsPLaceholder, 'page');
			}
		});
	},
	/**
	 * Handles infinite scrolling for the Top purchased vehicle fit product list slider.
	 * Loads additional products when the user scrolls to the end.
	 *
	 * - Retrieves the total number of pages from the slider's data attribute.
	 * - Detects when the user reaches the horizontal scroll end.
	 * - Calls `productSlider.loadMoreProducts` to load the next page of products.
	 *
	 * @function loadTopPurchasedVehicleFitProducts
	 * @returns {void}
	 */
	loadTopPurchasedVehicleFitProducts: function () {
		let vehicleFitProductListSlider = $('.topPurchasedVehicleProductListSlider'),
			productsPLaceholder = $(".topPurchasedVehicleProductListSlider .defaultProductSlider"),
			page = 1,
			url = new URL(window.location.href),
			path = url.pathname + url.search + url.hash,
			maxPages = vehicleFitProductListSlider.data('pageCount');
		$(".topPurchasedVehicleProductListSlider .horizontalCustomScrollbar").on("scroll", function () {
			let $this = $(this);
			if (!productSlider.isLoading && page < maxPages && $this.scrollLeft() + $this.innerWidth() >= $this[0].scrollWidth - 10) {
				productSlider.isLoading = true;
				page++;
				productSlider.loadMoreProducts(path, page, 'loadMoreTopPurchasedVehicleProducts', productsPLaceholder, 'purchased_page');
			}
		});
	},

	/**
	 * Loads more products via AJAX request when triggered.
	 *
	 * - Displays a loading indicator before the request.
	 * - Sends an AJAX GET request to fetch the next set of products.
	 * - Appends the received products to the slider container.
	 * - Calls `customSlider()` to update the UI.
	 * - Hides the loading indicator after completion.
	 * - Handles errors and prevents multiple simultaneous requests.
	 *
	 * @param {string} url - The endpoint URL for fetching products.
	 * @param {number} page - The page number to load.
	 * @param {string} ajax - The AJAX request type identifier.
	 * @param {jQuery} productsPlaceholder - The jQuery object representing the container where the new products should be appended.
	 * @param {string} paginationPageVar - The pagination query parameter name ('page' for vehicle fit products, 'purchased_page' for top purchased products).
	 * @returns {void}
	 */
	loadMoreProducts: function(url, page, ajax, productsPLaceholder, paginationPageVar) {
		let loadingContainer = productsPLaceholder.closest('.customSlider').find('.loading-indicator');
		$.ajax({
			url: url,
			type: "GET",
			data: {
				ajax: ajax,
				[paginationPageVar]: page
			},
			beforeSend: function () {
				loadingContainer.show();
			},
			success: function (data) {
				productsPLaceholder.append(data);
				GlobalInIt.customSlider();
				productSlider.isLoading = false;
			},
			error: function () {
				console.error("Error loading products");
				productSlider.isLoading = false;
				loadingContainer.hide();
			},
			complete: function () {
				loadingContainer.hide();
			}
		});
	},
	
	/**
	 * Adds an item, accessory or warranty to the cart.
	 * @param {Array} items List of product IDs to add to the cart
	 * @param {String} redeemedCode Coupon code to redeem.
	 * @param {Number} mainItemId Product ID of main item
	 * @returns {undefined}
	 */
	addItemToCart: function(items, redeemedCode, mainItemId) {
		let canSendFacebookTrackingRequest;
		
		$.ajax({
			url: "/cart/addMultiple",
			type: "POST",
			dataType: "json",
			data: {
				format: "json",
				products: items,
				redeemedCode: redeemedCode,
				mainItemId: mainItemId
			},
			success: function(data) {
				if (data && data.products) {
					$.each(data.products, function(key, item) {
						productSlider.itemsAddedToCart[key] = item.cartItemID;
						
						// Facebook pixel
						if ($.inArray(key, productSlider.facebook_tracked_item_ids) > -1) {
							canSendFacebookTrackingRequest = false;
						} else {
							canSendFacebookTrackingRequest = true;
							productSlider.facebook_content_ids.push(key);
							productSlider.facebook_tracked_item_ids.push(key);
						}
					});
					
					// Facebook pixel
					if (canSendFacebookTrackingRequest) {
						let facebookPixelParameters = {
							content_type: 'product',
							content_ids: productSlider.facebook_content_ids
						};
						
						// GTM event fire
						dataLayer = dataLayer || [];
						dataLayer.push({'event': 'addedToCart', 'facebookPixelParameters': facebookPixelParameters});
					}
					$('#ajaxloader').hide();
					if ($(document.body).data('triggeredAddToCartBtn') == 'addToCartAutoLoadCouponProductCat') {
						$.each(data.products, function(key, item) {
							if (item.isMainItem === true) {
								if(item.isAfgItem === true) {
									window.location.href = "/cart/add-ons/item/" + item.cartItemID + "/justAdded/1";
								}
								else {
									window.location.href = "/cart/add-ons/item/" + item.cartItemID;
								}
							}
						});
					}
				}
			}
		});
	},
};

export default productSlider;
